import {
    ReactSVG,
    PythonSVG,
    JavaScriptSVG,
    TailwindCSSSVG,
    MySQLSVG,
    RedisSVG,
    MongoDBSCG,
    FlaskSVG,
    FastAPISVG,
    DockerSVG,
    KubernetesSVG,
    NodeSVG,
    SwaggerSVG,
    GraphQLSVG,
    UbuntuSVG,
    AWSSVG,
    GitSVG,
    KafkaSVG, GoSVG, JavaSVG, SpringSVG,
} from "../components/ui/icons";

let color = "#9ca3af";

export const techonologyIconList = [
    {
        name: "Go",
        icon : (
            <GoSVG
                size={42}
                color={color}
            />
        )
    },
    {
        name: "Python",
        icon: (
            <PythonSVG
                size={35}
                color={color}
            />
        ),
    },
    {
        name: "Java",
        icon: (
            <JavaSVG
                size={35}
                color={color}
            />
        ),
    },
    {
        name: "Spring",
        icon: (
            <SpringSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Flask",
        icon: (
            <FlaskSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "MySQL",
        icon: (
            <MySQLSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Redis",
        icon: (
            <RedisSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Mongo",
        icon: (
            <MongoDBSCG
                size={35}
                color={color}/>
        )
    },
    {
        name: "GraphQL",
        icon: (
            <GraphQLSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "JavaScript",
        icon: (
            <JavaScriptSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "React",
        icon: (
            <ReactSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Node",
        icon: (
            <NodeSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "TailwindCSS",
        icon: (
            <TailwindCSSSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Docker",
        icon: (
            <DockerSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Kafka",
        icon: (
            <KafkaSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Kubernetes",
        icon: (
            <KubernetesSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Swagger",
        icon: (
            <SwaggerSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Ubuntu",
        icon: (
            <UbuntuSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "AWS",
        icon: (
            <AWSSVG
                size={35}
                color={color}/>
        )
    },
    {
        name: "Git",
        icon: (
            <GitSVG
                size={35}
                color={color}/>
        )
    },
];
